<template>
  <div class="validate-container">
    <div class="validate-header">
      <div class="validate-header-content">
        <!-- デフォルトのヘッダーコンテンツ -->
        <slot name="header-content" />
      </div>
    </div>
    <div class="validate-content">
      <div class="validate-content-description">
        <!-- デフォルトの説明 -->
        <slot name="description" />
      </div>
      <ul class="validate-list">
        <!-- バリデーションリスト -->
        <slot name="validation-list" />
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValidationContainer'
}
</script>

<style scoped>
.validate-container {
  overflow: hidden;
}

.validate-header {
  background: #FF4EB2;
  color: white;
  padding: 16px 20px;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 1.4;
  position: relative;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}


.validate-header-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.validate-header-content span {
  padding-left: 8px;
  text-align: left;
}

.validate-content {
  background-color: #FFE1F2;
  padding: 16px 20px;
  color: #333;
  font-size: 13px;
  line-height: 1.5;
}

.validate-content-description {
  display: flex;
  align-items: center;
}

.validate-icon {
  color: #FF69B4;
  margin-right: 8px;
  font-size: 14px;
}

.validate-list {
  padding-top: 12px;
  padding-left: 16px;
  list-style: none;
}

.validate-list li {
  padding: 4px 0 4px 16px;
  position: relative;
  font-size: 12px;
  color: #555;
}

.validate-list li:before {
  content: "•";
  font-weight: bold;
  position: absolute;
  left: 0;
}
</style>